module.exports = __webpack_public_path__ + "static/media/banner_ley_21420_desktop.dd7bad1c.png";